import alt from '../alt';
import userAction from '../actions/userAction';

class userStore {
    constructor() {
        this.bindActions(userAction);
        this.role = 0;
        this.staffId = 0;
        this.userName = "";
        this.userImage = "";
        this.warningMsg = "";
        this.token = "";
        this.subordinate = [];
        this.permission = [];
        this.processing = false;
        this.isUserLogin = false;
        this.isNewUser = false;
        this.isPwdReset = false;
        this.isfgPwdReset = false;
        this.isPasswordChange = false;
        this.isfgPwdSend = false;
    }

    onProcessing(data) {
        this.processing = data;
    }

    onWarningMsg(data) {
        this.warningMsg = data;
    }
    onIsfgPwdSend(data){
        this.isfgPwdSend = data;
    }
    onUserLoginSuccess(data) {

        if (!data.isNewUser) {
            this.role = data.role;
            this.staffId = data.staffId;
            this.userName = data.userName;
            this.userImage = data.userImage;
            this.subordinate = data.subordinate;
            this.permission = data.permission;
            this.isUserLogin = true;
            this.isNewUser = false;

            sessionStorage.setItem('ui', data.token);
        } else {
            this.isUserLogin = true;
            this.isNewUser = data.isNewUser;
            this.token = data.token;
            this.staffId = data.staffId;
            this.userName = data.userName;
            this.userImage = data.userImage;
            this.subordinate = data.subordinate;
            this.permission = data.permission;
        }
    }
    onUserLoginFail(){
        this.isUserLogin = false; 
        sessionStorage.clear()
    }
    onResetPasswordSuccess(data) {
        this.warningMsg = "Password reset successfully";
        this.isPwdReset = true;
        this.isNewUser = false;
        sessionStorage.setItem('ui', data);
    }

    onResetFgPasswordSuccess(data){
        this.warningMsg = "An email has sent to your mailbox";
        this.isfgPwdReset = true;
    }
    onChangePasswordSuccess(data) {
        this.warningMsg = "Password changed successfully";
        this.isPasswordChange = true;
    }
    onLogout(){
        this.isUserLogin = false;
        this.isNewUser = false;
        sessionStorage.clear();
    }
}
export default alt.createStore(userStore, 'userStore');


// WEBPACK FOOTER //
// ./app/stores/userStore.js